module.exports = __webpack_public_path__ + "img/eight8Orange.a82e6910.jpg";